export default __webpack_public_path__ + "static/media/emoji.49e3f374.svg";